var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5957 3.75146C15.1653 3.75146 15.7047 4.00981 16.0605 4.45459L20.6845 10.2358C20.7899 10.3676 20.8383 10.5362 20.8173 10.7036L20.3291 14.6089C20.2117 15.5469 19.414 16.2513 18.4687 16.2515H3.17574C2.23023 16.2515 1.43182 15.5471 1.31441 14.6089L0.82711 10.7036C0.806185 10.5362 0.853585 10.3676 0.958945 10.2358L5.58297 4.45459C5.93879 4.00981 6.47822 3.75146 7.04781 3.75146H14.5957ZM7.04781 5.00146C6.85795 5.00146 6.67814 5.08758 6.55953 5.23584L2.74703 10.0015H8.32223C8.66721 10.0017 8.94723 10.2814 8.94723 10.6265C8.94748 11.6618 9.78685 12.5015 10.8222 12.5015C11.8574 12.5012 12.697 11.6616 12.6972 10.6265C12.6972 10.2813 12.977 10.0015 13.3222 10.0015H18.8964L15.0839 5.23584C14.9653 5.08758 14.7855 5.00146 14.5957 5.00146H7.04781Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.4efd79e90e2012840aadcbddc6257eb2.svg";
export { ForwardRef as ReactComponent };